export const VIEW_MODES = {
  SPLIT: 'split',
  LIST: 'list',
};

export const FOOTER_ID = 'dbs-footer';

export const ROUTES = {
  vacancies: '/vacatures',
  uploadCv: '/cv-uploaden',
  addVacancy: '/vacature-plaatsen',
};

export const REQUIRED_FIELDS_KEYS = {
  NAME: 'name',
  PHONE_NUMBER: 'phoneNumber',
  CITY: 'city',
  CV: 'CV',
  MOTIVATION: 'motivation',
};
